/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Choose_Type_Company_DescriptionInputs */

const en_clients_create_choose_type_company_description = /** @type {(inputs: Clients_Create_Choose_Type_Company_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register a corporate client using a CNPJ.`)
};

const pt_br2_clients_create_choose_type_company_description = /** @type {(inputs: Clients_Create_Choose_Type_Company_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadastre um cliente pessoa jurídica utilizando o CNPJ.`)
};

/**
* | output |
* | --- |
* | "Register a corporate client using a CNPJ." |
*
* @param {Clients_Create_Choose_Type_Company_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_create_choose_type_company_description = /** @type {((inputs?: Clients_Create_Choose_Type_Company_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Choose_Type_Company_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_choose_type_company_description(inputs)
	return pt_br2_clients_create_choose_type_company_description(inputs)
});